enum KeyEventCommand {
    DrayageCreate = "1",
    DrayageList = "l",
    DrayageImport = "i",
    Settings = "n",
    Logout = "o",

    Autofill = "0",
    Submit = "Enter",
    ToggleDevMode = "1"
}

export default KeyEventCommand;
